// DO NOT REFACTOR WITHOUT UNDERSTANDING
// Uses single-interval + Date.now() to avoid race conditions

import { useEffect, useRef, useState } from "react";
import { signOut } from "aws-amplify/auth";

export default function useSessionTimeout() {
  // ---- CONFIG (5 min test) ----
  const INACTIVITY_LIMIT = 5 * 60 * 1000;
const WARNING_DURATION = 30 * 1000;


  // ---- STATE ----
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(30);

  // ---- REFS ----
  const lastActivityRef = useRef(Date.now());
  const intervalRef = useRef(null);

  // ---- ACTIVITY TRACKER ----
  useEffect(() => {
    const updateActivity = () => {
      lastActivityRef.current = Date.now();
    };

    const events = ["click", "keydown", "scroll", "touchstart"];
    events.forEach(e => window.addEventListener(e, updateActivity));

    return () => {
      events.forEach(e => window.removeEventListener(e, updateActivity));
    };
  }, []);

  // ---- MAIN TIMER (ONE INTERVAL ONLY) ----
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const now = Date.now();
      const idleTime = now - lastActivityRef.current;

      // show warning
      if (
        idleTime >= INACTIVITY_LIMIT - WARNING_DURATION &&
        idleTime < INACTIVITY_LIMIT
      ) {
        setShowWarning(true);
        const remaining =
          Math.ceil((INACTIVITY_LIMIT - idleTime) / 1000);
        setCountdown(remaining);
      }

      // logout
      if (idleTime >= INACTIVITY_LIMIT) {
        clearInterval(intervalRef.current);
        signOut().then(() => {
          window.location.href = "/admin/login";
        });
      }
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, []);

  // ---- STAY LOGGED IN ----
  const stayLoggedIn = () => {
    lastActivityRef.current = Date.now();
    setShowWarning(false);
    setCountdown(30);
  };

  return { showWarning, countdown, stayLoggedIn };
}
